import { ReactNode } from "react";

interface FormFieldProps {
  children: ReactNode;
  label: string;
}

export default function FormField({ children, label }: FormFieldProps) {
  return (
    <div className="d-flex flex-column gap-4">
      <label>{label}</label>
      {children}
    </div>
  );
}
